(function() {
  'use strict';

  function DashboardReorderController(
    DashboardTemplates,
    $translate,
    Utils,
    Notify
  ) {
    var ctrl = this;
    ctrl.loaded = false;
    ctrl.reorderInfo = $translate.instant(
      'Drag and drop dashboards templates in the list below in order to re-order them. ' +
      'The order you set here will determine the order these dashboards are shown on the ' +
      'user\'s profile and few other places. ' +
      'The order is saved automatically. ' +
      'When you are done, click the <strong>Done</strong> button.');

    Utils.setPageTitle('Reorder Dashboard');

    DashboardTemplates.findAll()
      .then(function(templates) {
        ctrl.templates = _.sortBy(templates, 'order');

        ctrl.loaded = true;
      });

    ctrl.actions = [
      {
        label: $translate.instant('Done'),
        icon: 'icon-save',
        route: ['/dashboard-templates'],
        klass: 'btn-success'
      }
    ];

    ctrl.reorder = function(evt) {
      evt.models.forEach(function(model, index) {
        var order = index + 1;
        if (model.order === order) {
          return;
        }
        model.order = order;
        DashboardTemplates.updateOrder(model._id, order)
          .then(function(data) { model._rev = data.rev; })
          .catch(Utils.showError);
      });
      Notify.success('Order successfully updated!', 'Success');
    };
  }

  DashboardReorderController.$inject = [
    'DashboardTemplatesService',
    '$translate',
    'UtilsService',
    'NotifyService'
  ];

  angular.module('component.dashboardTemplates')
    .controller('DashboardReorderController', DashboardReorderController);
})();

